// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "560a64f2c13ea51e1365" + "-chunk.js";
};